import { render, staticRenderFns } from "./TaskSaveTemplateModal.vue?vue&type=template&id=2089d022&"
import script from "./TaskSaveTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./TaskSaveTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports